import * as commander from "commander";
import container from "./inversify.config";
import TYPES from "./TYPES";
import { ConsoleUI } from "./utils/ConsoleUI";
import { AuthenticationServer } from "./signup/AuthenticationServer";
import { KotennaApi } from "./lib/kotenna/KotennaApi";
import { ServiceConfiguration } from "./utils/ServiceConfiguration";

commander
    .description("When invoked without parameters, launches an interactive login process to authenticate the current user\n" +
        "and generates a new auth token, saved in in the $HOME\n\n" +
        "If the interactive login is not available, (eg: no browser is available locally),\n" +
        "generate a token/secret key pair at https://dashboard.porketta.io and specify **both** options -n and -s.")
    .option("-n, --name <name>", "The token name")
    .option("-s, --secret <secret>", "The token secret")
    .option("-f, --force", "Ignore any existing token and generates new credentials, overwriting any existing credential")
    .action(async (options) => {

        const force = options.force || false;
        let username = options.name;
        let password = options.secret;

        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const authServer = container.get<AuthenticationServer>(TYPES.AuthenticationServer);
        const kotenna = container.get<KotennaApi>(TYPES.KotennaApi);
        const config = container.get<ServiceConfiguration>(TYPES.ServiceConfiguration);

        if(config.isConfigurationPersisted() && !force) {
            return ui.loaderFail("Authentication already configured - command ignored");
        }

        if( username && password) {
            await config.save({username, password}, 'default', force);
            ui.loaderSuccess("Authentication completed");
            process.exit(0);
        }

        const auth = await authServer.getAuthenticationToken();

        username = `porcliv1${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;

        ui.loaderStart("Creating CLI auth token");
        const authRes = await kotenna.credentials(auth.accessToken, username);
        password = authRes.password;
        await config.save({username, password}, 'default', force);

        ui.loaderSuccess("Authentication succeed");

        process.exit(0);

    });

commander.parse(process.argv);
